<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Operaciones</th>
              <th scope="col" class="text-center">Evento</th>
              <th scope="col" class="text-center">Fecha Inicio</th>
              <th scope="col" class="text-center">Fecha Fin</th>
              <th scope="col" class="text-center">Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <td class="text-center">
                <div v-if="item.inbox > 1">
                  <div class="btn-group btn-sm" role="group" aria-label="Basic example">
                    <button class="btn btn-success" @click="getEvent(item.id)"><i
                        class="fa  fa-arrow-circle-right"></i></button>
                  </div>
                </div>
                <div v-else><button class="btn btn-sm btn-primary" @click="doAction(item, 2)"><i
                      class="fa fa-envelope-o" </i></button></div>
              </td>
              <td style="max-width: 250px;">{{ item.title }}</td>
              <td>{{ formatDate(item.init_date) }}</td>
              <td>{{ formatDate(item.end_date) }}</td>
              <td>Interno</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :totalItems="list.length" :itemsPerPage="itemsPerPage" @page-change="handlePageChange" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, inject, computed } from "vue";
import axios from "@/includes/connection";

import Pagination from "@/pages/components/Pagination.vue";

const list = ref([]);

const swal = inject("$swal");

import { useRouter } from 'vue-router'
const router = useRouter()

onMounted(() => {
  loadItems();
});

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

function loadItems() {
  axios
    .get("/event/all")
    .then((response) => {
      //console.log("list", response.data);
      if (response.data) {
        list.value = response.data;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

const getEvent = (code) => {
  //console.log(code);
  router.push({ name: 'event_certification', params: { id: code } })
};

const sortedList = computed(() => {
  return list.value.sort((a, b) => b.id - a.id);
});

let currentPage = ref(1);
let itemsPerPage = ref(10);

// let paginatedItems = computed(() => {
//   const startIndex = (currentPage.value - 1) * itemsPerPage.value;
//   const endIndex = startIndex + itemsPerPage.value;
//   return list.value.slice(startIndex, endIndex);
// });

let paginatedItems = computed(() => {
  // First, filter the list to include only items with inbox > 1
  const filteredList = sortedList.value.filter(item => item.inbox > 1);

  // Then, apply pagination to the filtered list
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return filteredList.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
